<template id="outside-notifs-modal">
  <div class="outside-notif" v-bind:class="{'success-box': !hasError, 'danger-box': hasError}">
    <p>{{message}} <md-icon @click.native="closeBox">close</md-icon></p>
  </div>
</template>
<script type="text/javascript">
  export default {
    props: ['message', 'hasError'],
    methods: {
      closeBox(){
        this.$emit('closeNotif', true)
      }
    }
  }
</script>
<style lang="scss">
  .outside-notif {
    width: fit-content;
    // padding: 10px;
    margin-bottom: 20px;
    border-radius: 5px;
    height: 60px;
    p {
      padding: 10px;
      vertical-align: center;
      font-weight: bold;
      // line-height: 40px;
    }
    .md-icon {
      color: white !important;
    }
  }
  .success-box {
    background-color: #407739;
  }
  .danger-box {
    background-color: #c20c0c;
  }
</style>
